// extracted by mini-css-extract-plugin
export default {"story":"OurStory_story__4Bf+k","story__inner":"OurStory_story__inner__IkfUX","story__label":"OurStory_story__label__0pP1J"};